<div class="table-toolbar">
  <mat-slide-toggle
    data-cy="checklist-expanded-view"
    [checked]="expandedView()"
    (change)="expandedView.set($event.checked)"
    >{{ "checklistdefinition.ui.expandedView" | translate }}</mat-slide-toggle
  >
  @if (sectionIds().length) {
    <w-h-button
      type="basic"
      color="primary"
      dataCy="checklist-sections-toggle-all"
      [matIcon]="allCollapsed() ? 'unfold_more' : 'unfold_less'"
      [text]="
        (allCollapsed() ? 'ui.expandall' : 'ui.collapseall')
          | translate: { count: checkCount() }
      "
      (clicked)="toggleAllSections()"
    />
  }
</div>
<div class="table-scroll">
  <div class="table" role="table" [class.table--compact]="!expandedView()">
    <div class="row row--header" role="row" ngBeeChecklistStickyHeader>
      <span role="columnheader">#</span>
      <span role="columnheader">{{
        "checklistdefinition.check.model.description" | translate
      }}</span>
      <span role="columnheader">{{
        "checklistdefinition.check.model.additionalinformation" | translate
      }}</span>
      <span role="columnheader">{{
        "checklistdefinition.check.model.measurementtype" | translate
      }}</span>
      <span role="columnheader">{{
        "checklistdefinition.check.model.resulttype" | translate
      }}</span>
      <span role="columnheader">{{
        "checklistdefinition.check.model.unit" | translate
      }}</span>
      <span role="columnheader">{{
        "checklistdefinition.check.model.mandatory" | translate
      }}</span>
    </div>

    @for (group of groups(); track group.trackId) {
      @let collapsed = collapsedSections().has(group.trackId);
      <div role="rowgroup">
        @if (group.title !== null) {
          <div class="banner-row" role="row">
            <span class="banner-heading" role="rowheader">
              <button
                type="button"
                class="collapse-toggle collapse-toggle--with-title"
                [attr.aria-expanded]="!collapsed"
                (click)="toggleSection(group.trackId)"
              >
                <mat-icon aria-hidden="true">expand_more</mat-icon>
                <span class="banner-title">{{ group.title }}</span>
              </button>
            </span>
            <span class="banner-meta">
              <span
                class="entry-count"
                [style.--numOfEntries]="group.rows.length"
              ></span>
              @if (group.defaultEnabled) {
                <span class="wh-status green">{{
                  "checklistdefinition.model.section.defaultenabled" | translate
                }}</span>
              }
            </span>
          </div>
        }

        @if (!collapsed) {
          @for (row of group.rows; track row.trackId) {
            <div class="row" role="row">
              <span role="cell"
                ><span class="position">{{ row.position }}</span></span
              >
              <span role="cell" class="description cell--text">{{
                row.description
              }}</span>
              <span role="cell" class="cell--text">
                @if (row.additionalInformation) {
                  {{ row.additionalInformation }}
                } @else {
                  <span class="muted">-</span>
                }
              </span>
              <span role="cell">
                @if (row.measurementTypeKey) {
                  {{ row.measurementTypeKey | translate }}
                } @else {
                  <span class="muted">-</span>
                }
              </span>
              <span role="cell">
                @if (row.resultTypeId !== null) {
                  <span
                    class="wh-status"
                    [class]="row.resultTypeId | statusColor: 'checkResultType'"
                    >{{
                      "checklistdefinition.check.enum.resulttype." +
                        row.resultTypeId | translate
                    }}</span
                  >
                } @else {
                  <span class="muted">-</span>
                }
              </span>
              <span role="cell">
                @if (row.unitKey) {
                  {{ row.unitKey | translate }}
                } @else {
                  <span class="muted">-</span>
                }
              </span>
              <span role="cell">
                <span
                  class="wh-status"
                  [class]="row.mandatory | statusColor: 'checkMandatory'"
                  >{{
                    (row.mandatory ? "app.yes.label" : "app.no.label")
                      | translate
                  }}</span
                >
              </span>
            </div>
          } @empty {
            <div class="row row--empty" role="row">
              <span role="cell" class="muted">-</span>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
